import { createContext, useContext, useState, useCallback, ReactNode } from 'react';
import { DataProvider, DexieProvider, createRemoteProvider, isRemoteMode } from './dataProvider';

interface DataProviderContextType {
  provider: DataProvider;
  isRemote: boolean;
  serverURL: string;
  connectToServer: (url: string) => void;
  disconnectFromServer: () => void;
}

const DataProviderCtx = createContext<DataProviderContextType>({
  provider: DexieProvider,
  isRemote: false,
  serverURL: '',
  connectToServer: () => {},
  disconnectFromServer: () => {},
});

export const useDataProvider = () => useContext(DataProviderCtx);

export const DataProviderWrapper = ({ children }: { children: ReactNode }) => {
  const [provider, setProvider] = useState<DataProvider>(DexieProvider);
  const [serverURL, setServerURL] = useState('');

  const connectToServer = useCallback((url: string) => {
    const remote = createRemoteProvider(url);
    setProvider(remote);
    setServerURL(url);
  }, []);

  const disconnectFromServer = useCallback(() => {
    setProvider(DexieProvider);
    setServerURL('');
  }, []);

  return (
    <DataProviderCtx.Provider value={{
      provider,
      isRemote: provider.mode === 'remote',
      serverURL,
      connectToServer,
      disconnectFromServer,
    }}>
      {children}
    </DataProviderCtx.Provider>
  );
};
